import { $qs, $qsa } from '../utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);



function toggleEntryPoints(day, month, year) {
    const entryPoints = $qsa('[data-target="entry-point"]');
    const entryFromSpans = $qsa('[data-target="entry-from"]');
    const entryPointsMessage = $qs('[data-target="entry-points-message"]');
    const usefullLinks = $qs('[data-target="useful-links"]');

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // Month is 0-indexed, so we add 1.

    const age = currentYear - year - (parseInt(month) < 9 ? 0 : 1);

    console.log('age', age);
    console.log('current year', currentYear);

    // Calculate starting years for each entry point with updated deadlines
    const startingYear11 = currentYear + (11 - age);
    const startingYear13 = currentYear + (13 - age);
    const startingYear16 = currentYear + (16 - age);

    console.log('startingYear11', startingYear11);
    console.log('startingYear13', startingYear13);
    console.log('startingYear16', startingYear16);

    // Calculate entry deadlines
    const deadline11 = new Date(startingYear11 - 1, 9, 15); // 15 September one year before entry
    const deadline13 = new Date(startingYear13 - 1, 11, 1); // 1 November one years before entry
    const deadline16 = new Date(startingYear16 - 1, 8, 1); // 01 August one year before entry
    //const deadline11 = new Date(startingYear11 - 1, 8, 1); // 20 September one year before entry
    //const deadline13 = new Date(startingYear13 - 2, 8, 1); // 20 October two years before entry
    //const deadline16 = new Date(startingYear16 - 1, 8, 1); // 01 September one year before entry

    console.log('deadline11', deadline11);
    console.log('deadline13', deadline13);
    console.log('deadline16', deadline16);
    console.log('currentDate', currentDate);

    // Hide all entry points first
    [...entryPoints, entryPointsMessage, usefullLinks].forEach(entryPoint => entryPoint.classList.add('hidden'));

    // Display available entry points and their starting years with deadlines
    if (age < 11 && currentDate < deadline11) {
        [entryPoints[0], entryPointsMessage, usefullLinks].forEach(element => element.classList.remove('hidden'));
        entryFromSpans[0].textContent = startingYear11;
    }
    if (age < 13 && currentDate < deadline13) {
        [entryPoints[1], entryPointsMessage, usefullLinks].forEach(element => element.classList.remove('hidden'));
        entryFromSpans[1].textContent = startingYear13;
        entryPointsMessage.classList.remove('hidden');
    }
    if (age < 16 && currentDate < deadline16) {
        [entryPoints[2], entryPointsMessage, usefullLinks].forEach(element => element.classList.remove('hidden'));
        entryFromSpans[2].textContent = startingYear16;
        entryPointsMessage.classList.remove('hidden');
    }
}

function handleFormSubmit(event) {
    event.preventDefault();

    const formData = new FormData(event.target);
    const day = parseInt(formData.get('ac_day'));
    const month = parseInt(formData.get('ac_month'));
    const year = parseInt(formData.get('ac_year'));

    toggleEntryPoints(day, month, year);

    // update ac_day, ac_month, ac_year search params
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('ac_day', day);
    urlParams.set('ac_month', month);
    urlParams.set('ac_year', year);
    window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
}

function checkAge() {
    const form = $qs('[data-target="age-checker-form"]');

    form && form.addEventListener('submit', handleFormSubmit);

    // get ac_day, ac_month, ac_year search params and toggle entry points on load if they exist
    const urlParams = new URLSearchParams(window.location.search);
    const day = parseInt(urlParams.get('ac_day'));
    const month = parseInt(urlParams.get('ac_month'));
    const year = parseInt(urlParams.get('ac_year'));

    // if (day && month && year) {
        toggleEntryPoints(day, month, year);
    // }
}

function AgeChecker() {
    if (!$qs('.page-template-tpl-age-checker')) return;
    
    checkAge();
}

export default AgeChecker;